import { z } from "zod";
import { AccountSchema } from "../entities";

/** `GET /api/accounts`. */
export const ListAccountsResponseSchema = z.object({
  accounts: z.array(AccountSchema),
});
export type ListAccountsResponse = z.infer<typeof ListAccountsResponseSchema>;

/** `POST /api/accounts/sync` — refresh from Toss (cached, ACCOUNT is 1 req/s). */
export const SyncAccountsResponseSchema = z.object({
  accounts: z.array(AccountSchema),
  syncedAt: z.number().int(),
});
export type SyncAccountsResponse = z.infer<typeof SyncAccountsResponseSchema>;
